export const EMPTY_SELECT_OPTION = null
